import { registerModuleDataProvider } from '../../../providers/CustomDataProvider';
import { activityTasksDataProvider } from './dataProvider';

// 注册 activity/tasks 模块的数据提供者
export function initActivityTasksDataProvider() {
  registerModuleDataProvider('activity-task', activityTasksDataProvider);
}

// 自动初始化
initActivityTasksDataProvider();
